import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'xemex-inline-heading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './inline-heading.component.scss',
  template: `<h4 class="heading"><ng-content /></h4>`,
})
export class InlineHeadingComponent {}
